
import Player from '@/utils/game/Player';
import { Options, Vue } from 'vue-class-component';

import Logo from '../components/Logo.vue'
import PlayersTable from '../components/PlayersTable.vue'
import Countdown from '../components/Countdown.vue'

import genWorker from '../utils/GenWorker'

@Options({
  components: {
    Logo, PlayersTable, Countdown
  },

  data: () => ({
    countdownStarted: false,
    stars: 1,
    nextLevel: 0,
    autoStartTimerId: null,
    autoStartCountdown: 10
  }),

  methods: {
    resetGame() {
      this.$store.dispatch('resetGameState');
    },

    startCountdown() {
      this.$store.dispatch('setLevelNumber', this.$store.state.gameState.lvlNumber + this.stars);
      this.$store.dispatch('setGenLevelState', false);

      genWorker.postMessage({
        type: 'genLevel',
        payload: {
          level: this.$store.state.gameState.lvlNumber,
          settings: {
            useFakeLetters: this.$store.state.useFakeLetters,
            useHiddenLetters: this.$store.state.useHiddenLetters
          }
        }
      });

      this.countdownStarted = true;
    },

    autoStartCountdownDecrease() {

      if (this.autoStartCountdown > 0) {
        this.autoStartCountdown --;
      }
      else if (!this.countdownStarted) {
        this.startCountdown();
        clearInterval(this.autoStartTimerId);
      }

    },

    startGame() {
      this.$store.dispatch('resetLastPlayerPoints');
      this.$router.push('/game');
    },

    exit() {
      this.resetGame();
      this.$router.push('/');
    }
  },

  beforeMount() {
    if (!this.$store.state.gameStarted) {
      this.$router.push('/');
      return;
    }

    const ratio = this.$store.state.gameState.earnedPoints/this.$store.state.gameState.lvlData.maxPoints;

    if (ratio >= .70 && ratio < .87) {
      this.stars = 2;
      this.nextLevel = this.$store.state.gameState.lvlNumber + 2;
    }
    else if (ratio >= .87) {
      this.stars = 3;
      this.nextLevel = this.$store.state.gameState.lvlNumber + 3;
    }
    else {
      this.nextLevel = this.$store.state.gameState.lvlNumber + 1;
    }

    this.$store.dispatch('saveSettings');

    this.autoStartTimerId = setInterval(this.autoStartCountdownDecrease, 1000);
  },

  beforeUnmount () {
    if (this.autoStartTimerId) {
      clearInterval(this.autoStartTimerId);
    }
  }
})
export default class NextLevel extends Vue {}
